module.exports = __webpack_public_path__ + "img/calendar-7_fill.f69bc2eb.svg";